import './animations.js';
import './app.js';
import './header.js';
import './slider.js';